import type { SelectHTMLAttributes } from 'react';

import { controlClass, type FieldSize } from './fieldControl';

/**
 * Native <select> with the shared control styling plus a consistent custom
 * chevron (native arrows differ per-browser). `wrapperClassName` controls the
 * outer width when the select is not inside a stretching flex column.
 */
export function Select({
  size = 'md',
  className = '',
  wrapperClassName = '',
  children,
  ...rest
}: {
  size?: FieldSize;
  wrapperClassName?: string;
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'>) {
  return (
    <div className={`relative ${wrapperClassName}`.trim()}>
      <select
        className={controlClass(
          size,
          `w-full cursor-pointer appearance-none pr-9 ${className}`,
        )}
        {...rest}
      >
        {children}
      </select>
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-3"
      >
        <path
          d="M6 8l4 4 4-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
